import { useState } from 'react'
import { useI18n } from '../i18n'
import { api } from '../lib/api'
import { thumb } from '../lib/img'
import { renderOgCard } from '../lib/ogcard'
import { myName } from '../lib/dialogs'
import { useSession } from '../store/session'

/** Ход в комнату: рисунок + вопрос (необязательно). Вопрос делает ход загадкой, которую судит ИИ. */
export function ReplyQuestion() {
  const { t } = useI18n()
  const s = useSession()
  const [qIdx, setQIdx] = useState<number>(1)
  const [custom, setCustom] = useState('')
  const [truth, setTruth] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(false)

  // 0,1 — пресеты, 2 — свой, 3 — без вопроса
  const options = [...t.share.presets, t.share.custom, t.replyq.noQuestion]
  const question = qIdx === 3 ? null : qIdx === 2 ? custom.trim() || t.share.presets[0] : t.share.presets[qIdx]

  const send = async () => {
    if (!s.replyDialogId || !s.beforePNG || busy) return
    setBusy(true)
    setErr(false)
    try {
      const img = await thumb(s.beforePNG, 640, 0.72)
      const ogImg = await renderOgCard({ img: s.beforePNG, who: myName(), question })
      const r = await api.sendMessage(s.replyDialogId, {
        kind: 'drawing',
        img,
        ogImg,
        question,
        truth: question ? truth.trim() || null : null,
        replyTo: s.pendingReplyTo,
        sessionId: s.replySessionId,
      })
      const fresh = await api.getDialog(s.replyDialogId)
      s.set({
        activeDialog: fresh,
        focusMsgId: r.messages[0]?.id ?? null,
        mode: 'free',
        strokes: [],
        beforePNG: null,
        pendingReplyTo: null,
        replySessionId: null,
        replyDialogId: null,
      })
      s.go('room')
    } catch {
      setErr(true)
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="screen">
      <h2>{t.replyq.title}</h2>
      <div className="solo">
        <img src={s.beforePNG ?? ''} alt="" />
      </div>
      <p className="muted" style={{ fontSize: 14, marginTop: 10 }}>{t.replyq.lead}</p>
      <div className="chips">
        {options.map((q, i) => (
          <button key={q} className={'chip' + (i === qIdx ? ' sel' : '')} onClick={() => setQIdx(i)}>{q}</button>
        ))}
      </div>
      {qIdx === 2 && (
        <input className="ans-input" placeholder={t.replyq.customPlaceholder} value={custom} onChange={(e) => setCustom(e.target.value)} />
      )}
      {question && (
        <>
          <p className="muted" style={{ fontSize: 12, marginTop: 10 }}>{t.dialogs.truthLabel} · {t.dialogs.truthHint}</p>
          <input className="ans-input" style={{ marginTop: 6 }} placeholder={t.dialogs.truthPlaceholder} value={truth} onChange={(e) => setTruth(e.target.value)} />
        </>
      )}
      {err && <div className="banner">{t.errors.threadFailed}</div>}
      <div className="btn-row">
        <button className="btn btn-blue" disabled={busy} onClick={send}>{t.replyq.send}</button>
      </div>
    </section>
  )
}
